import React from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { useTheme } from "@emotion/react";
import geoData from "../../../assets/data/geoData.json";

const MapChart = ({ divisions }) => {
  const theme = useTheme();

  // # JSX
  return (
    <ComposableMap projection="geoEqualEarth" style={{ height: "270px" }}>
      <Geographies
        geography={geoData}
        stroke={theme.palette.secondary.light}
        strokeWidth={0.5}
      >
        {({ geographies }) =>
          geographies.map((geo) => {
            const isHighlighted = divisions.includes(
              geo.properties["Alpha-2"]?.toLowerCase()
            );
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                stroke={theme.palette.grey[6]}
                fill={
                  isHighlighted
                    ? theme.palette.secondary.main
                    : theme.palette.tertiary.lightGrey
                }
                onClick={() => console.log(geo.properties)}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};

export default MapChart;
